import React, { Component } from "react";
import styles from "./Header.module.scss";
//import menuImg from "../../assets/icon_bars_light.svg";
import DOMPurify from "dompurify";
import { ThemeContext } from "../../../Context/ThemeContext";
import { Context as LanguageContext } from "../../../Context/LanguageContext";
import { isMobile } from "react-device-detect";

const MenuIcon = ({ color = "#ffffff", className, ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5 8H27"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M5 16H27"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M5 24H27"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };
    window.addEventListener("resize", this.updateDimensions);
  }

  static contextType = LanguageContext;

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  _renderContent = (item, themeContext) => {
    const urlToRender = item.url;
    const foundValue = item.values.find(
      (textValue) => textValue.languageCode === this.context.locale
    );
    const textToRender = foundValue ? foundValue.value : "";

    return (
      <>
        {" "}
        {urlToRender !== undefined ? (
          <a
            href={urlToRender}
            className={styles["link-text-custom"]}
            style={{
              color:
                themeContext?.headerSettings?.textColour !== undefined
                  ? themeContext?.headerSettings?.textColour
                  : "#484848",
              "--header--hover-color":
                themeContext?.headerSettings?.textHoverColour !== undefined
                  ? themeContext?.headerSettings?.textHoverColour
                  : "#008489",
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textToRender, {
                  ADD_ATTR: ["target"],
                  // sanitize: true, TODO: Re-implement this!
                }),
              }}
            />
          </a>
        ) : (
          <span className={styles["header-text"]}>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textToRender, {
                  ADD_ATTR: ["target"],
                  // sanitize: true, TODO: Re-implement this!
                }),
              }}
            />
          </span>
        )}
      </>
    );
  };

  renderLanguageSelector = (theme) => {
    return (
      <LanguageContext.Consumer>
        {({ locale, selectLanguage }) => {
          const languages = theme?.headerSettings?.languages || [];

          if (languages.length === 0) {
            return null;
          }
          return (
            <div className={styles["language-selector-container"]}>
              {languages.map((lang) => (
                <span
                  key={lang.languageCode}
                  className={`${styles["language-selector"]} ${
                    lang.languageCode === locale
                      ? styles["language-selector-active"]
                      : ""
                  }`}
                  style={{
                    color:
                      lang.languageCode === locale
                        ? theme?.headerSettings?.textHoverColour ||
                          theme?.hoverColour
                        : theme?.headerSettings?.textColour ||
                          theme?.primaryColour,
                  }}
                  onClick={() =>
                    this.handleLanguageChange(lang.languageCode, selectLanguage)
                  }
                >
                  {lang.value}
                </span>
              ))}
            </div>
          );
        }}
      </LanguageContext.Consumer>
    );
  };

  handleLanguageChange = (langCode, selectLanguage) => {
    selectLanguage(langCode);
  };

  render() {
    const { showMenu } = this.props;
    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const themeContext = theme?.theme;
          return (
            <div
              className={styles["Header"]}
              style={{
                color: isMobile
                  ? themeContext?.headerSettings?.mobileTextColour !== undefined
                    ? themeContext?.headerSettings?.mobileTextColour
                    : "#484848"
                  : themeContext?.headerSettings?.textColour !== undefined
                  ? themeContext?.headerSettings?.textColour
                  : "#484848",
                background: isMobile
                  ? themeContext?.headerSettings?.mobileBackgroundColour !==
                    undefined
                    ? themeContext?.headerSettings?.mobileBackgroundColour
                    : "#ffffff"
                  : themeContext?.headerSettings?.backgroundColour !== undefined
                  ? themeContext?.headerSettings?.backgroundColour
                  : "#ffffff",
                "--hover-color": isMobile
                  ? themeContext?.headerSettings?.mobileTextHoverColour !==
                    undefined
                    ? themeContext?.headerSettings?.mobileTextHoverColour
                    : "#ffffff"
                  : themeContext?.headerSettings?.textHoverColour !== undefined
                  ? themeContext?.headerSettings?.textHoverColour
                  : "#008489",
              }}
            >
              {isMobile ? (
                <div className={styles["header-outer-container-mobile"]}>
                  <div className={styles["header-inner-container"]}>
                    <div
                      className={styles["header-inner-left"]}
                      style={{
                        width: "80px",
                        flex: "0 0 80px",
                      }}
                    >
                      <div
                        style={{
                          float: "left",
                          paddingLeft: "10px",
                        }}
                        className={styles["menu-button-container"]}
                        onClick={showMenu}
                      >
                        <MenuIcon
                          color={
                            themeContext?.headerSettings?.mobileTextColour ||
                            (themeContext?.headerSettings
                              ?.mobileBackgroundColour === "#ffffff" ||
                            themeContext?.headerSettings
                              ?.mobileBackgroundColour === undefined ||
                            themeContext?.headerSettings
                              ?.mobileBackgroundColour === "white"
                              ? "#484848"
                              : "#ffffff")
                          }
                          className={styles["menu-button"]}
                          aria-label="Menu icon opens travel profile"
                          role="img"
                        />
                      </div>
                    </div>
                    <div
                      className={styles["header-inner-center"]}
                      style={{
                        flex: "1 1 auto",
                        position: "relative",
                        textAlign: "center",
                      }}
                    >
                      <img
                        height={33}
                        width={"40%"}
                        style={{
                          left: "50%",
                          top: "50%",
                          maxWidth: "90px",
                          objectFit: "contain",
                        }}
                        src={themeContext?.desktopHeader?.imageUrl}
                        alt="You. Smart. Thing. logo"
                      />
                    </div>

                    <div
                      className={styles["header-inner-right"]}
                      style={{
                        width: "80px",
                        flex: "0 0 80px",
                        textAlign: "right",
                        zIndex: 100,
                      }}
                    >
                      {this.renderLanguageSelector(themeContext)}
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles["header-outer-container"]}>
                  <div className={styles["header-inner-container"]}>
                    <div className={styles["header-inner-left"]}>
                      {themeContext?.desktopHeader?.headerValues?.[0] !==
                        undefined &&
                        this._renderContent(
                          themeContext.desktopHeader.headerValues[0],
                          themeContext
                        )}
                    </div>
                    <div className={styles["header-inner-center"]}>
                      {themeContext?.desktopHeader?.headerValues?.[1] !==
                        undefined &&
                        this._renderContent(
                          themeContext.desktopHeader.headerValues[1],
                          themeContext
                        )}
                    </div>
                    <div className={styles["header-inner-right"]}>
                      {this.renderLanguageSelector(themeContext)}
                    </div>{" "}
                  </div>
                </div>
              )}
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}

export default Header;
